// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraPopupBaloonTemplate from '@front/templates/TerceraPopupBaloonTemplate.html';
import { Control } from './Control';
export class TerceraPopupBaloon extends Control {
    constructor() {
        super();
        this.time = 3000;
        this.timeout = null;
    }
    show(data) {
        if (!isNullOrUndefined(this.timeout)) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        void this.set({
            text: Resources.getResource(data.locKey),
            iconUrl: data.iconUrl
        });
        void this.set('isShown', true);
        this.timeout = setTimeout(() => {
            void this.set('isShown', false);
            this.timeout = null;
        }, this.time);
    }
}
TerceraPopupBaloon.States = {
    WorkspaceLocked: {
        locKey: 'workspace.Lock.Message',
        iconUrl: 'tabStripItemLocked'
    },
    WorkspaceUnlocked: {
        locKey: 'workspace.Unlock.Message',
        iconUrl: 'tabStripItemUnlocked'
    },
    TradingLocked: {
        locKey: 'ribbon.enviroment.NotificationWindow.lockTrading',
        iconUrl: 'tabStripItemLocked'
    },
    TradingUnlocked: {
        locKey: 'ribbon.enviroment.NotificationWindow.UnlockTrading',
        iconUrl: 'tabStripItemUnlocked'
    }
};
Control.extendWith(TerceraPopupBaloon, {
    template: TerceraPopupBaloonTemplate,
    data: function () {
        return {
            text: '',
            iconUrl: '',
            isShown: false
        };
    }
});
